import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCountry, deleteCountry, fetchCountryList, updateCountry } from "./CountryListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCountryListAsync = createAsyncThunk(
  "CountryList/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchCountryList(page);

      const resp = data.response;
      // console.log("data's response", data.response)

      return {
        countries: resp.data,  // The array of job data
        totalCountries: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteCountryListAsync = createAsyncThunk(
  'CountryList/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteCountry(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCountryListAsync = createAsyncThunk(
  'CountryList/update',
  async ({ uuid, CountryData }, { rejectWithValue }) => {
    try {
      const response = await updateCountry(uuid, CountryData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addCountryListAsync = createAsyncThunk(
  "CountryList/add",
  async (newCountry) => {
    try {
      const data = await addCountry(newCountry);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const CountrySlice = createSlice({
  name: "Country",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountryListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCountryListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addCountryListAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addCountryListAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateCountryListAsync.pending, (state) => {
        state.loading = true;
        // console.log("Loading")
        state.error = null;
      })
      .addCase(updateCountryListAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("data", state.data)
        state.data = state.data.map((CountryData) =>
            CountryData.uuid === action.payload.uuid ? action.payload : CountryData
        );
      })
      .addCase(updateCountryListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteCountryListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCountryListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (CountryData) => CountryData.uuid !== action.payload
        );
      })
      .addCase(deleteCountryListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const selectCountry = (state) => state.country.data.countries;
export const selectCountryTotal = (state) => state.country.data.totalCountries;

export default CountrySlice.reducer;
